__turbopack_context__.v({
  "black-disclaimer-link": "translated-text-module-scss-module__xM30yW__black-disclaimer-link",
  "blue-disclaimer-link": "translated-text-module-scss-module__xM30yW__blue-disclaimer-link",
  "blue-disclaimer-link-no-underline": "translated-text-module-scss-module__xM30yW__blue-disclaimer-link-no-underline",
  "dotted-list": "translated-text-module-scss-module__xM30yW__dotted-list",
  "white-disclaimer-link": "translated-text-module-scss-module__xM30yW__white-disclaimer-link",
  "white-disclaimer-link-no-underline": "translated-text-module-scss-module__xM30yW__white-disclaimer-link-no-underline",
});
